<template>
    <v-btn                
        @click="buttonClicked"
        :class="customClass"
        :disabled="isDisabled"
        variant="flat"        
    >
        <span v-if="!isLoading">{{ buttonText }}</span>
        <v-progress-circular 
            v-else
            :size="24"
            color="white"
            indeterminate
        />
    </v-btn>
</template>

<script>
export default {
    name: "LoadingButton",
    emits: ['onClick'],
    props: {
        buttonText: {
            type: String,
            default: "Click"            
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        customClass: {  
            type: String,
            default: ""
        }
    },
    data() {
        return {
            isLoading: false,
        }
    },
    computed: {
        isDisabled() {
            return this.disabled || this.isLoading;
        }
    },
    methods: {
        buttonClicked() {
            if (!this.isLoading) {
                this.isLoading = true;
                this.$emit('onClick', this.finishLoading);
            }
        },
        finishLoading() {
            this.isLoading = false;
        }
    }
}
</script>

<style scoped>


.mint-btn {
  background-color: var(--duallo-accent);
  color: #000;
  font-weight: 600;
  transition: 0.3s;
}

.mint-btn:hover {
  background-color: #4de0c0;
}

</style>